export const DOWNLOAD_FILE = "DOWNLOAD_FILE";
export const DOWNLOAD_TEXT_FILE = "DOWNLOAD_TEXT_FILE";
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const GET_STATS = "GET_STATS";
export const GET_VERIFIED = "GET_VERIFIED";
export const GET_RECORDED = "GET_RECORDED";